import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IDriverRequest extends IBaseEntity {
    id?: number;
    driver?: any;
    driverId?: number;
    driverRequestType?: string;
    driverRequestTypeId?: number;
    date?: any;
    information?: string;
}

export class DriverRequest extends BaseEntity implements IDriverRequest {
    id?: number;
    driverId?: number;
    driver?: any;
    driverRequestTypeId?: number;
    driverRequestType?: string;
    date?: any;
    information?: string;

    constructor(driverRequest?) {
        super();
        if (driverRequest) {
            this.id = driverRequest.id;
            this.driverId = driverRequest.driverId;
            this.driver = driverRequest.driver;
            this.driverRequestTypeId = driverRequest.driverRequestTypeId;
            this.driverRequestType = driverRequest.driverRequestType;
            this.date = driverRequest.date;
            this.information = driverRequest.information;
        }
    }

    clone(): DriverRequest {
        return new DriverRequest(this);
    }

    get discriminator(): any {
        return this.id;
    }
}
